import React from "react";
import { ShimmerThumbnail } from "react-shimmer-effects";
const AccidentSheetLoader = () => {

  return (
    <>
      <div className="d-flex align-items-center justify-content-center">
        <div style={{ width: '150px' }}><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
      </div>
      <div className="d-flex mg-t-30">
        <div style={{ width: '70px' }}><ShimmerThumbnail height={70} className="rounded-2 mb-0" /></div>
        <div style={{ width: '70px' }} className="mg-l-10"><ShimmerThumbnail height={70} className="rounded-2 mb-0" /></div>
        <div style={{ width: '70px' }} className="mg-l-10"><ShimmerThumbnail height={70} className="rounded-2 mb-0" /></div>
      </div>
      <div style={{ width: '120px' }} className="mg-t-30"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
      <div style={{ width: '100px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
      <div className="mx-n-20 pd-x-20 pd-b-15 border-bottom border-gray border-b-w-6">
        <div style={{ width: '70px' }} className="mg-t-30"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '80%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '100%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '90%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '90px' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
      </div>
      <div className="mx-n-20 pd-x-20 pd-b-15 border-bottom border-gray border-b-w-6">
        <div style={{ width: '120px' }} className="mg-t-15"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '100px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>

        <div style={{ width: '70px' }} className="mg-t-30"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '80%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '100%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '90%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
      </div>
      <div className="mx-n-20 pd-x-20 pd-b-15 border-bottom border-gray border-b-w-6">
        <div style={{ width: '120px' }} className="mg-t-15"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '100px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>

        <div style={{ width: '70px' }} className="mg-t-30"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '80%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '100%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '90%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
      </div>
      <div className="mx-n-20 pd-x-20 pd-b-15 border-bottom border-gray border-b-w-6">
        <div className="row gutter-15">
          <div className="col-6 mg-t-15">
            <div style={{ width: '100px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
            <div style={{ width: '60px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          </div>
          <div className="col-6 mg-t-15">
            <div style={{ width: '100px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
            <div style={{ width: '60px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          </div>
        </div>
      </div>
      <div>
        <div style={{ width: '170px' }} className="mg-t-15"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '140px' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '80px' }} className="mg-t-30"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '165px' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
      </div>
    </>
  )
}

export default AccidentSheetLoader;